import {Ability, AbilityClass, AbilityBuilder} from "@casl/ability";

type Subjects = 'Anagrafica' | 'Referto' | 'Calendario';
type Actions = 'Read' | 'Search' | 'Modify' | 'View' | 'Create' | 'Edit' | 'Delete';

export type AppAbility = Ability<[Actions, Subjects]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
//export type AppAbilityBuilder = AbilityBuilder<AppAbility>;

type DefinePermissions = (builder: AbilityBuilder<AppAbility>) => void;


// Realm-> Role -> Rule: (subject, [action])
const ABILITIES = {
    'utente': {
        'admin': {
            'Anagrafica': ['View', 'Modify', 'Search'],
            'Referto': ['View']
        }
    },
    'laboratorio': {
        'admin': {
            'AbilitazioneUtente': ['View', 'Modify'],
        },
        'operator': {
            'Referto': ['View', 'Modify']
        }
    },
    'centroPrenotazione': {
        'admin': {
            'Calendario': ['View', 'Modify'],
            'Anagrafica': ['View']
        },
        'operator': {
            'Calendario': ['View'],
            'Anagrafica': ['View']
        }
    },
    'ricercatore': {
        'admin': {
            'AbilitazioneUtente': ['View', 'Modify'],
            'Anagrafica': ['View']
        },
        'operator': {
            'Anagrafica': ['View']
        }
    }
};


const laboratoryResultsAbilityBuilder = (builder: AbilityBuilder<AppAbility>, edit:boolean=false) => {
    const {can} = builder;

    can("Read", 'Referto');
    can("Create", 'Referto');

    if (edit) {
        can("Edit", "Referto");
        can("Delete", "Referto");
    }

    return builder;
};

const userAbilityBuilder = (builder: AbilityBuilder<AppAbility>): AbilityBuilder<AppAbility> => {
    const {can} = builder;

    can("Search", 'Referto');
    can("View", 'Referto');
    can("Modify", 'Anagrafica');
    can("View", 'Anagrafica');
    can("Search", 'Calendario');
    can("View", 'Calendario');
    can("Modify", 'Calendario');

    return builder;
}


const defineSergenRules = (roles: string []) => {
    let abilityBuilder: AbilityBuilder<AppAbility> = new AbilityBuilder(AppAbility);

    roles.forEach((role) => {
       switch (role) {
           case 'user':
               abilityBuilder = userAbilityBuilder(abilityBuilder);
               break;
           case 'lab-results':
               abilityBuilder = laboratoryResultsAbilityBuilder(abilityBuilder);
               break;
           case 'lab-results-edit':
               abilityBuilder = laboratoryResultsAbilityBuilder(abilityBuilder, true);
               break;
           default:
               break;
       }
    });

    return abilityBuilder;
};

type RulesFunct = (roles: string[]) => AbilityBuilder<AppAbility>;
// Mi riservo la possibilità di avere più reami
const realmRules: Record<string, RulesFunct> = {
    sergencovid: defineSergenRules, // Lettura e Modifica dati anagrafica, Lettura dati sierologico

};

export function buildAbilityFor(realm: string, roles: string[]): AbilityBuilder<AppAbility> {
    return realmRules[realm](roles);
}